import { gates } from '../../constants/gates';
import { scopes } from '../../constants/scopes';
export const useEnrichmentActionPolicies = ({
  hasScope,
  hasGate
}) => {
  const hasAccessEnrichment = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.DATA_ENRICHMENT_ACCESS));
  const hasAccessPlatform = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS));
  const hasFree = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.BREEZE_INTELLIGENCE_FREE));
  const showEnrichmentActions = hasAccessPlatform || hasFree;
  const showSmartPropertiesActions = showEnrichmentActions;
  const showSmartFillBatch = showSmartPropertiesActions && !!(hasGate !== null && hasGate !== void 0 && hasGate(gates.SMART_FILL_BATCH));
  const showSmartFillList = showSmartPropertiesActions && !!(hasGate !== null && hasGate !== void 0 && hasGate(gates.SMART_FILL_LIST));
  return {
    canUpgrade: !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.BILLING_ACCESS)),
    enrichmentIcon: 'breezeSingleStar',
    isDisabled: !hasAccessEnrichment,
    showEnrichmentActions,
    showSmartPropertiesActions,
    showSmartFillBatch,
    showSmartFillList
  };
};